/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import ModalDetailNftStyled from './styled'
import { notification } from 'antd'
import { CLOSE_BTN, LINE_GUILD_GRADIENT } from 'assets/images'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import { NUMBER } from 'apps/constants'
import { GetRaceListParams } from 'models'
import { RaceTable } from 'features/Race/components'
import { useAppSelector } from 'hooks'
import { detailNftColumns } from 'utils/columns'
import { handleAsyncRequest } from 'utils/helper'
import guildApi from 'apis/guildApi'
import ReactPaginate from 'react-paginate'

interface ModalProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  rowSelected: any
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TEN,
  page: NUMBER.ONE
}

export default function DetailNft({ onCloseButtonClick, rowSelected }: ModalProps) {
  const [, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [dataTable, setDataTable] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(true)
  const [total, setTotal] = useState()

  const columns = useMemo(() => {
    return detailNftColumns
  }, [profile])

  useEffect(() => {
    if (!rowSelected)
      return
    const fetchingData = async () => {
      const [error, result]: any = await handleAsyncRequest(
        guildApi.getVaultItems(profile.guild_id, {
          ...params,
          rarity: rowSelected.rarity_type,
          type: rowSelected.body_part,
          setName: rowSelected.set_name
        })
      )
      if (error) {
        return null
      }
      if (result) {
        const dataNft = result.data
        if (dataNft?.records) {
          const formatData = dataNft?.records.map((it: any) => {
            return {
              ...it,
              avatar: it.img,
              raceName: it.name,
            }
          })
          setDataTable(params.page > NUMBER.ONE ? [...dataTable, ...formatData] : formatData)
          setTotal(dataNft?.total || NUMBER.ZERO)
        }
        setLoading(false)
      }
    }
    fetchingData()
  }, [rowSelected])

  const handlePageClick = (event: any) => {
    setParams({ ...params, page: event.selected + 1 })
  }

  return (
    <Modal>
      <ModalDetailNftStyled>
        {contextHolder}
        <div className='donate-coin-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-modal'>
            <div className={`color-primary`}>{t(`${GUILD_MESSAGE}.guildVaultDetail`)}</div>
          </div>
          <div className='content-modal'>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <RaceTable
              columns={columns}
              data={dataTable}
              raisePage={setParams}
              loader={!loading}
              params={params}
              checkLoadingPage={false}
              totalRace={total}
              currentUser={profile}
              noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
              isShowVipIcon={true}
            />
            <div className='pagination-footer'>
              <div className='pagination custom'>
                {dataTable.length > 0 && Number(total) > 10 && (
                  <div className='paginate'>
                    <ReactPaginate
                      nextLabel='>'
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={Math.ceil(Number(total) / params.limit)}
                      previousLabel='<'
                      pageClassName='page-item'
                      pageLinkClassName='page-link'
                      previousClassName='page-item'
                      previousLinkClassName='page-link'
                      nextClassName='page-item'
                      nextLinkClassName='page-link'
                      breakLabel='...'
                      breakClassName='page-item'
                      breakLinkClassName='page-link'
                      containerClassName='pagination'
                      activeClassName='active'
                      forcePage={params.page ? +params.page - 1 : 0}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalDetailNftStyled>
    </Modal>
  )
}
